import { render, staticRenderFns } from "./navbar-main.vue?vue&type=template&id=198968c5"
import script from "./navbar-main.vue?vue&type=script&lang=js"
export * from "./navbar-main.vue?vue&type=script&lang=js"
import style0 from "./navbar-main.vue?vue&type=style&index=0&id=198968c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports